import {RemoteGetAuthSchedule} from 'data/usecases/private/authorizations';
import {GetAuthSchedule} from 'domain/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthSchedule = (): GetAuthSchedule =>
	new RemoteGetAuthSchedule(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.schedule),
		makeAuthorizeHttpClientDecorator(),
	);
